export default function isContentAssigned(contentEnrolment) {
  return !!contentEnrolment && !contentEnrolment.deleted;
}
